module.exports = __webpack_public_path__ + "img/logo-aayi.1fc5a974.png";